export default "__VITE_ASSET__BBNMK7nO__"